<template>
  <div class="smb-sales_container">
    <div class="smb-sales_container_title">
      Company Detail Info
    </div>
    <div
      class="smb-sales_container_content"
      v-if="isApply || isEdit || isRenew || isResubmit"
    >
      <el-form ref="form" label-position="top" :model="formData" :rules="rules">
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="companyName">
            <template #label>
              <div class="smbsales-label_required">
                Company Full Name
              </div>
            </template>
            <el-select
              ref="companyNameSelectRef"
              v-model="formData.companyName"
              placeholder=""
              allow-create
              clearable
              filterable
              remote
              style="width: 100%"
              default-first-option
              :disabled="isEdit && !isSenior || (isSenior && !isAdmin) || isCompanyNameDisabled"
              @input.native="handleCompanyNameInput"
            >
              <el-option
                v-for="(item, index) in companyList"
                :key="index"
                :label="item.customerName"
                :value="item.customerName"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="address">
            <template #label>
              <div class="smbsales-label">
                Business License Address
              </div>
            </template>
            <el-input
              v-model="formData.address"
              @blur="event => (formData.address = event.target.value.trim())"
            />
          </el-form-item>
        </div>
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="companyFullName">
            <template #label>
              <div class="smbsales-label">
                Company Full Name (Local Language)
              </div>
            </template>
            <el-input
              v-model="formData.companyFullName"
              :disabled="isEdit && !isSenior"
              @blur="
                event => (formData.companyFullName = event.target.value.trim())
              "
            />
          </el-form-item>
          <el-form-item prop="companyWebsite">
            <template #label>
              <div class="smbsales-label">
                Company Website
              </div>
            </template>
            <el-input
              v-model="formData.companyWebsite"
              @blur="
                event => (formData.companyWebsite = event.target.value.trim())
              "
            />
          </el-form-item>
        </div>
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="legalRepresentative">
            <template #label>
              <div class="smbsales-label">
                Legal Representative
              </div>
            </template>
            <el-input
              v-model="formData.legalRepresentative"
              @blur="
                event =>
                  (formData.legalRepresentative = event.target.value.trim())
              "
            />
          </el-form-item>
          <el-form-item prop="organizationCode">
            <template #label>
              <div class="smbsales-label">
                Organization Code
                <el-tooltip placement="top" effect="light">
                  <img
                    src="@/assets/tool-tip_icon.svg"
                    width="18px"
                    height="18px"
                    alt=""
                  />
                  <template #content>
                    <div class="text-content">
                      Note: This is a number assigned by local govermment
                      agencise to identify a business within the local market.
                      Examples of include the VAT Number in Europe, the Siret
                      Number in France, the Company Number in Australia, and the
                      State Registry Number in Brazil.
                    </div>
                  </template>
                </el-tooltip>
              </div>
            </template>
            <el-input
              v-model="formData.organizationCode"
              @blur="
                event => (formData.organizationCode = event.target.value.trim())
              "
            />
          </el-form-item>
        </div>
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="peopleNumber">
            <template #label>
              <div class="smbsales-label">
                Number of Employees
              </div>
            </template>
            <el-input-number
              :precision="0"
              :min="0"
              :controls="false"
              v-model="formData.peopleNumber"
              @change="handleEmployeesChange"
            />
          </el-form-item>
          <el-form-item prop="setUpDate">
            <template #label>
              <div class="smbsales-label">
                Date of Foundation
              </div>
            </template>
            <el-date-picker
              v-model="formData.setUpDate"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="smb-sales_container_table" v-if="isDetail">
      <el-row class="smb-sales_mb-40">
        <el-col :span="12">
          <div class="smb-sales_label">Company Full Name</div>
          <div class="smb-sales_value save-white-space">{{ detailData.companyName || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Business License Address</div>
          <div class="smb-sales_value">{{ detailData.address || "-" }}</div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40">
        <el-col :span="12">
          <div class="smb-sales_label">Company Full Name (Local Language)</div>
          <div class="smb-sales_value save-white-space">{{ detailData.companyFullName || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Company Website</div>
          <div class="smb-sales_value">
            {{ detailData.companyWebsite || "-" }}
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40">
        <el-col :span="12">
          <div class="smb-sales_label">Legal Representative</div>
          <div class="smb-sales_value">
            {{ detailData.legalRepresentative || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Organization Code</div>
          <div class="smb-sales_value">
            {{ detailData.organizationCode || "-" }}
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40">
        <el-col :span="12">
          <div class="smb-sales_label">Number of Employees</div>
          <div class="smb-sales_value">
            {{ detailData.peopleNumber || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Date of Foundation</div>
          <div class="smb-sales_value">
            {{
              detailData.setUpDate
                ? dayjs(detailData.setUpDate).format("YYYY-MM-DD")
                : "-"
            }}
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40">
        <el-col :span="12">
          <div class="smb-sales_label">
            Business Registration Country/Region
          </div>
          <div class="smb-sales_value">{{ detailData.countryName || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Authorized Country/Region</div>
          <div class="smb-sales_value">
            {{ detailData.authRegionName || "-" }}
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40">
        <el-col :span="12">
          <div class="smb-sales_label">Ruijie Sales</div>
          <div class="smb-sales_value">
            {{ detailData.ruijieSalesName || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Authorized City</div>
          <div class="smb-sales_value">{{ detailData.cityNames || "-" }}</div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40">
        <el-col :span="12">
          <div class="smb-sales_label">Partner Admin Account</div>
          <div class="smb-sales_value">
            {{ detailData.masterAccount || "-" }}
          </div>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
    </div>
    <!--高级编辑审批详情-->
    <div class="smb-sales_container_table" v-if="isSeniorEditApprove">
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12">
          <div class="smb-sales_label">Company Full Name</div>
          <!--除管理员之外，不允许修改该值 所以这里不做新旧值对比-->
          <div class="smb-sales_value save-white-space">{{ detailData.companyName || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Business License Address</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('address')">
              <div class="new-value">
                {{ detailData.address }}
              </div>
              <div class="old-value">{{ oldEditDetail['address'] ? `(${oldEditDetail['address']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.address || "-" }}
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12">
          <div class="smb-sales_label save-white-space">Company Full Name (Local Language)</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('companyFullName')">
              <div class="new-value save-white-space">{{ detailData.companyFullName }}</div>
              <div class="old-value save-white-space">{{ oldEditDetail['companyFullName'] ? `(${oldEditDetail['companyFullName']})` : void 0 }}</div>
            </div>
            <template v-else>
              <div class="save-white-space">
                {{ detailData.companyFullName || "-" }}
              </div>
            </template>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Company Website</div>
          <div class="smb-sales_value">

            <div v-if="oldEditDetail.hasOwnProperty('companyWebsite')">
              <div class="new-value">
                {{ detailData.companyWebsite }}
              </div>
              <div class="old-value">{{ oldEditDetail['companyWebsite'] ? `(${oldEditDetail['companyWebsite']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.companyWebsite || "-" }}
            </template>

          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12">
          <div class="smb-sales_label">Legal Representative</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('legalRepresentative')">
              <div class="new-value">
                {{ detailData.legalRepresentative }}
              </div>
              <div class="old-value">{{ oldEditDetail['legalRepresentative'] ? `(${oldEditDetail['legalRepresentative']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.legalRepresentative || "-" }}
            </template>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Organization Code</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('organizationCode')">
              <div class="new-value">
                {{ detailData.organizationCode }}
              </div>
              <div class="old-value">{{ oldEditDetail['organizationCode'] ? `(${oldEditDetail['organizationCode']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.organizationCode || "-" }}
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12">
          <div class="smb-sales_label">Number of Employees</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('peopleNumber')">
              <div class="new-value">
                {{ detailData.peopleNumber }}
              </div>
              <div class="old-value">{{ oldEditDetail['peopleNumber'] ? `(${oldEditDetail['peopleNumber']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.peopleNumber || "-" }}
            </template>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Date of Foundation</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('setUpDate')">
              <div class="new-value">
                {{ formatDate(detailData.setUpDate) }}
              </div>
              <div class="old-value">{{ oldEditDetail['setUpDate'] ? `(${formatDate(oldEditDetail['setUpDate'])})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ formatDate(detailData.setUpDate) }}
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12">
          <div class="smb-sales_label">
            Business Registration Country/Region
          </div>
          <div class="smb-sales_value">

            <div v-if="oldEditDetail.hasOwnProperty('countryName')">
              <div class="new-value">
                {{ detailData.countryName }}
              </div>
              <div class="old-value">{{ oldEditDetail['countryName'] ? `(${oldEditDetail['countryName']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.countryName || "-" }}
            </template>

          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Authorized Country/Region</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('authRegionNames')">
              <div class="new-value">
                {{ detailData.authRegionName }}
              </div>
              <div class="old-value">{{ oldEditDetail['authRegionNames'] ? `(${oldEditDetail['authRegionNames']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.authRegionName || "-" }}
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12">
          <div class="smb-sales_label">Ruijie Sales</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('salesName')">
              <div class="new-value">
                {{ detailData.ruijieSalesName }}
              </div>
              <div class="old-value">{{ oldEditDetail['salesName'] ? `(${oldEditDetail['salesName']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.ruijieSalesName || "-" }}
            </template>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Authorized City</div>
          <div class="smb-sales_value">

            <div v-if="oldEditDetail.hasOwnProperty('cityNames')">
              <div class="new-value">
                {{ detailData.cityNames }}
              </div>
              <div class="old-value">{{ oldEditDetail['cityNames'] ? `(${oldEditDetail['cityNames']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.cityNames || "-" }}
            </template>

          </div>
        </el-col>
      </el-row>
      <el-row class="smb-sales_mb-40" :gutter="20">
        <el-col :span="12">
          <div class="smb-sales_label">Partner Admin Account</div>
          <div class="smb-sales_value">
            <div v-if="oldEditDetail.hasOwnProperty('masterAccount')">
              <div class="new-value">
                {{ detailData.masterAccount }}
              </div>
              <div class="old-value">{{ oldEditDetail['masterAccount'] ? `(${oldEditDetail['masterAccount']})` : void 0 }}</div>
            </div>
            <template v-else>
              {{ detailData.masterAccount || "-" }}
            </template>
          </div>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import dayjs from "dayjs";
import {formatDate} from "../../../utils";

export default {
  name: "companyDetailInfo",
  props: {
    // 编辑类型 基础 base 或者 高级senior 默认基础
    mode: {
      type: String,
      default: "base"
    },
    // 操作类型 申请 apply, 编辑 edit, 审批 approve， 默认申请
    type: {
      type: String,
      default: "apply"
    },
    isApply: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isResubmit: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    isCompanyNameDisabled: {
      type: Boolean,
      default: false
    },
    //是否是高级编辑审批页面
    isSeniorEditApprove: {
      type: Boolean,
      default: false
    },
    // 编辑修改后的数据
    oldEditDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        companyName: "", // 公司名称
        companyFullName: "", // 公司全称
        address: "", // 营业执照地址
        companyWebsite: "", // 公司网址
        legalRepresentative: "", // 法定代表人
        organizationCode: "", // 组织结构代码
        peopleNumber: void 0, // 员工数量
        setUpDate: "" // 注册日期
      },
      companyList: [],
    };
  },
  computed: {
    // 规则
    rules() {
      return this.isDetail
        ? {}
        : {
          companyName: [
            {
              required: true,
              message: "Please input Company Full Name",
              trigger: ["change", "blur"]
            }
          ]
        };
    },
    // 是否是高级编辑
    isSenior() {
      return this.mode === 'senior'
    },
    isAdmin() {
      return this.$store.state.user.isAdmin || this.$store.state.user.isAssistant;
    }
  },
  methods: {
    formatDate,
    value() {
      return value;
    },
    dayjs,
    // 搜索公司
    searchCompany(searchValue) {
      if (!searchValue) {
        this.companyList = [];
        this.formData.companyName = "";
        return;
      }
      API.searchCustomer({params: {keyword: searchValue.trim()}})
        .then(res => {
          let {status, data} = res.data;
          if (status === "200") {
            if (data && data.length < 1) {
              this.companyList = [];
            } else {
              this.companyList = data || [];
            }
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    handleCompanyNameInput(event) {
      this.formData.companyName = event.target.value.trim();
      this.searchCompany(this.formData.companyName);
    },
    // 设置formData 详情页不需要设置
    setFormData(formData) {
      if (this.isDetail || !formData) return;
      this.formData = formData;
      this.formData.peopleNumber = formData.peopleNumber ? Number(formData.peopleNumber) : void 0;
      this.$refs.form.clearValidate();
      // 合并对象
      // Object.assign(this.formData, formData);
    },
    // 获取formData
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(isSuccess => {
        isPass = isSuccess;
      });
      if (isPass) {
        return JSON.parse(JSON.stringify(this.formData));
      } else {
        return isPass;
      }
    },
    handleEmployeesChange(value) {
      if (!value || !value.toString().trim()) {
        this.$nextTick(() => {
          this.formData.peopleNumber = void 0
        });
      }
    }
  }
};
</script>
<style scoped>
.text-content {
  width: 360px;
}
</style>
<style>
.el-tooltip__popper {
  border: none !important;
  font-size: 16px;
  color: #505050;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08) !important;
}

.popper__arrow {
  border: none !important;
  z-index: 3000;
  transform: translateY(-1px);
}
</style>



// WEBPACK FOOTER //
// src/views/smbSales/components/companyDetailInfo.vue